"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTitleWrapper = exports.StyledTitle = exports.StyledTotal = exports.StyledItemWrapper = exports.StyledCheckbox = exports.StyledBlockIcon = exports.StyledSidebarSectionItem = void 0;
const ui_components_1 = require("@groupby/ui-components");
const Block_1 = __importDefault(require("@mui/icons-material/Block"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledSidebarSectionItem = styled_components_1.default.div `
  display: flex;
  align-items: center;
`;
exports.StyledBlockIcon = (0, styled_components_1.default)(Block_1.default) `
  &&& {
    margin: 0 0.6rem;

    font-size: 0.85rem;
    color: ${(props) => (props.$checked ? ui_components_1.baseColors.red : ui_components_1.baseColors.black)};

    cursor: pointer;
  }
`;
exports.StyledCheckbox = (0, styled_components_1.default)(ui_components_1.Checkbox) `
  &&& {
    margin: 0;
    padding: 0;

    .MuiSvgIcon-root.MuiSvgIcon-fontSizeSmall {
      font-size: 1rem;
    }
  }
`;
exports.StyledItemWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
`;
exports.StyledTotal = styled_components_1.default.div `
  padding-left: 0.5rem;
`;
exports.StyledTitle = styled_components_1.default.span `
  max-width: 7.8rem;
  overflow: hidden;
`;
exports.StyledTitleWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
